import {
    pxToRem,
    pxArrayToRem,
    getScrollbarStyle,
    checkboxClassName,
    labelClassName,
    accordionSlotClassNames,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

export const RootContainer: StyleRule = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    height: 'fit-content',
    overflow: 'hidden',
    width: pxToRem(460),
    padding: pxArrayToRem([0, 0, 32, 0]),

    [`& .closeButton`]: {
        position: 'absolute',
        top: pxToRem(28),
        right: pxToRem(34),
    },

    [`& .${accordionSlotClassNames.title}`]: {
        color: theme.siteVariables.colorScheme.default?.foreground,
    },
    [`& .${labelClassName}`]: {
        color: theme.siteVariables.colorScheme.default?.foreground,
    },
});

export const ContentContainer: StyleRule = ({ theme }) => ({
    ...getScrollbarStyle(theme, '0'),
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflowX: 'hidden',
    padding: 0,
    width: pxToRem(320),

    '> *:not(:first-child)': {
        marginTop: pxToRem(90),
    },

    [`& .${checkboxClassName}`]: {
        [`& .${labelClassName}`]: {
            fontSize: theme.siteVariables.fontSizes['caption03'],
            lineHeight: pxToRem(26),
            letterSpacing: theme.siteVariables.letterSpacingNormal,
        },
    },
});

export const BottomButtonsContainer: StyleRule = () => ({
    display: 'flex',
    flexDirection: 'column',
    padding: pxArrayToRem([32, 0, 0]),
    alignItems: 'flex-start',
    '> *:not(:first-child)': {
        marginTop: pxToRem(16),
    },
});
